import React from "react"
import ActOnNew from "../components/act-on/act-on-new"
import Nav from "../components/nav"
import Layout from "../components/layout"
import "../css/newsletter.css"
import snazzyGal from "../images/woman-with-laptop.png"
import SEO from "../components/seo"

function mailIcon () {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/>
    </svg>
  )
}

class Newsletter extends React.Component {

  constructor (props) {
    super(props)

    this.state = {
      form: false
    }
  }

  toggleFormPopup = () => {
  
    if (this.state.form) {
      document.getElementsByClassName('nl-formbox')[0].classList.remove('opened')
    } else {
      document.getElementsByClassName('nl-formbox')[0].classList.add('opened')
    }
    this.setState({
      form: !this.state.form
    })
    
  }

  render () {
    return (
      <Layout>
        <SEO title="Cyber Essentials Newsletter Sign Up" description="Interested in signing up for updates from Circadence? Join our Circadence Cyber Essentials Newsletter."/>
        <div className={this.state.form ? "form-popup visible" : "form-popup"} onClick={this.toggleFormPopup}>
          <div className="nl-formbox" >
            <div onClick={e => e.stopPropagation()}>
            <ActOnNew id="ad025d8f-4c78-4b30-862f-9e25185d828a" /></div>
          </div>
        </div>
        <div id="nl-main" className="mainContainer gray">
          <div id="nl-container" className="centeredContainer" style={{height: "100%", maxWidth: "none"}}>
            <div className="nl-header-img">
              <img src={snazzyGal}/>
            </div>
            <div className="nl-header-text">
              <h2>Sign Up for our Cyber Essentials Newsletter</h2>
              <p>Looking for a one-stop-shop for everything new and current in the world of cyber security training and readiness? Look no further. Our Cyber Essentials newsetter gives you everything you need to stay up to date on preparedness topics and skills development. Inside you'll find:
              </p>
              <ul style={{flexBasis: "100%"}}>
                <li>News, trends and issues in cyber security</li>
                <li>Enterprise, government, and higher education cyber readiness stories</li>
                <li>Cyber training solutions in the cloud - and more!</li>
              </ul>
              <button className="flat-button nl-signup" onClick={this.toggleFormPopup}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/>
                </svg>
                <p>Sign Up</p>
              </button>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default Newsletter
